// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"a42eae56","428":"1c5f0275"}[chunkId] + ".chunk.css";
};